import { IMAGES_CDN_LINK } from '../utils/links'

export const getPuzzleQuestAsset = (season: string, tier: number, type: 'active' | 'disabled' | 'frame' | 'stripe') => {
    return `${IMAGES_CDN_LINK}/puzzle/quest/${season}/reward-${tier}-${type}.svg`
}
